export enum CRMStatus {
  OPPORTUNITY_AVAILABLE = 'OPPORTUNITY_AVAILABLE',
  QUESTIONS = 'QUESTIONS',
  DEAL_PROSPECT = 'DEAL_PROSPECT',
  MATCH_DECLINED = 'MATCH_DECLINED',
  ACCEPTED = 'ACCEPTED',
  DEAL_WON = 'DEAL_WON',
  DEAL_LOST = 'DEAL_LOST',
}
